module.exports = __webpack_public_path__ + "img/section4-jp2.924f82bf.png";